import { createContext, useContext } from 'react';
import useIsScreen2XSAndUp from "../../../../hooks/device/useIsScreen2XSAndUp";
import useIsScreenXSAndUp from "../../../../hooks/device/useIsScreenXSAndUp";
import useIsScreenSMAndUp from "../../../../hooks/device/useIsScreenSMandUp";
import useIsScreenMDAndUp from "../../../../hooks/device/useIsScreenMDAndUp";

const ScreenContext = createContext();

export function useScreenContext() {
  const context = useContext(ScreenContext);
  if (!context) {
    console.error('useScreenContext: the component from which you are trying to use this context must be a ContextProviderScreen component descendant.');
  }
  return context;
}

export default function ContextProviderScreen({children}) {
  const isScreen2XSAndUp = useIsScreen2XSAndUp();
  const isScreenXSAndUp = useIsScreenXSAndUp();
  const isScreenSMAndUp = useIsScreenSMAndUp();
  const isScreenMDAndUp = useIsScreenMDAndUp();

  return (
    <ScreenContext.Provider value={
      {
        isScreen2XSAndUp,
        isScreenXSAndUp,
        isScreenSMAndUp,
        isScreenMDAndUp,
      }
    }>{children}</ScreenContext.Provider>
  );
}
